import { goBack } from 'connected-react-router'
import { Location, History } from 'history'
import { storageProvider } from '@ocean/configs'
import { AppDispatch } from 'store'

const REFERRERS = 'REFERRERS'
const MAX_SAVED_REFERRERS = 100

class ReferrerUtils {
  getLocationPath(location: Location) {
    const { pathname, search, hash } = location
    const hashValue = hash ? `#${hash}` : ''
    return `${pathname}${search}${hashValue}`
  }

  getPathname(locationPath?: string) {
    return locationPath?.replace('#', '?').split('?')[0]
  }

  storeReferrer(value: string) {
    let referrers = this.getReferrers()
    if (referrers.length >= MAX_SAVED_REFERRERS) referrers = referrers.slice(-MAX_SAVED_REFERRERS)
    if (referrers[referrers.length - 1] !== value)
      storageProvider.setItem(REFERRERS, JSON.stringify([...referrers, value]))
  }

  storeReferrers(values: string[]) {
    storageProvider.setItem(REFERRERS, JSON.stringify(values))
  }

  getReferrers() {
    return JSON.parse(storageProvider.getItem(REFERRERS) || '[]')
  }

  popReferrer(
    referrers: string[],
    currentLocationPath: string,
    saveChanges: boolean = true
  ): string | undefined {
    const referrersCopy = [...referrers]
    const lastReferrer = referrersCopy.pop()

    if (saveChanges) this.storeReferrers(referrers)

    if (this.getPathname(lastReferrer) === this.getPathname(currentLocationPath)) {
      return this.popReferrer(referrersCopy, currentLocationPath, saveChanges)
    }

    return lastReferrer
  }

  getLastReferrer(history: History, saveChanges: boolean = true) {
    const { location } = history
    const locationPath = this.getLocationPath(location)
    const referrers = this.getReferrers()
    return this.popReferrer(referrers, locationPath, saveChanges)
  }

  clearReferrers() {
    storageProvider.removeItem(REFERRERS)
  }

  deleteLastReferrer() {
    const referrers = this.getReferrers()
    referrers.pop()
    this.storeReferrers(referrers)
  }

  dispatchGoBack(dispatch: AppDispatch) {
    this.deleteLastReferrer()
    dispatch(goBack())
  }

  historyGoBack(history: History) {
    this.deleteLastReferrer()
    history.goBack()
  }

  historyGoToReferrer(history: History) {
    const referrer = this.getLastReferrer(history)
    if (referrer) return history.push(referrer)
    history.goBack()
  }

  addLastSlash(route: string) {
    return route[route.length - 1] === '/' ? route : `${route}/`
  }
}

export default new ReferrerUtils()
